import api from "@/Library/api.js";
import method from "@/Library/method.js";
let apiresult;
let controller;
let action;
let url;

export default {

    /** 获取宠物种类信息 **/
    GET_RECORD_TYPE_LIST(data) {
        controller='Record';
        action='GetRecordTypeList';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", data: data }); 
    },

    /* 新增宠物种类信息 ***/
    ADD_RECORD_TYPE(data) {
        controller='Record';
        action='AddRecordType';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", data: data }); 
    },

    /** 删除图标 **/
    DEL_RECORD_TYPE(data) {
        controller='Record';
        action='DelType';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", data: data }); 
    },

    /** 获取图标信息 **/
    GET_RECORD_TYPES(data) {
        controller='Record';
        action='GetTypes';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", data: data }); 
    },

    /** 修改图标信息 **/
    EDIT_RECORD_TYPES(data) {
        controller='Record';
        action='EditTypes';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", data: data }); 
    },

    /** 获取记录信息 **/
    GET_RECORD_LIST(data) {
        controller='Record';
        action='GetRecordList';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", data: data }); 
    },

    /** 删除记录信息 **/
    Del_record(data) {
        controller='Record';
        action='DelRecords';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", data: data }); 
    },

    /** 获取其它类型分类信息 **/
    GET_RECORD_OTHER_TYPE(data) {
        controller='Record';
        action='GetRecordOtherType';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", data: data }); 
    },

    /** 新增记录信息 **/
    ADD_RECORD(data) {
        controller='Record';
        action='AddRecord';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", data: data }); 
    },

    /** 获取记录详情信息 **/
    GET_RECORD_DETAIL(data) {
        controller='Record';
        action='GetRecordDetail';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", data: data }); 
    },

    /** 获取记录详情信息 **/
    GET_RECORD_INFOS(data) {
        controller='Record';
        action='GetRecordInfos';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", data: data }); 
    },

    /** 修改记录详情信息 **/
    EDIT_RECORD(data) {
        controller='Record';
        action='EditRecord';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", data: data }); 
    },

}